import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MaterialUIControllerProvider } from "context";
import { Auth0Provider } from "@auth0/auth0-react";
import App from "./App";

const rootElement = document.getElementById("app");
const root = ReactDOM.createRoot(rootElement);

root.render(
  <Auth0Provider
    domain="dev-37dscbbd41jvxm3y.us.auth0.com"
    clientId="u4PKKvdpzOiFT7mRlLeQLUV6KRZPuCEv"
    redirectUri={window.location.origin}
  >
    <BrowserRouter>
      <MaterialUIControllerProvider>
        <App />
      </MaterialUIControllerProvider>
    </BrowserRouter>
  </Auth0Provider>
);
